import * as ResourceApi from "../../../api/resources";
import {confirmDeleteSelectedTagAction, tagDeletedAction, Types} from "./actions";
import {Observable} from "rxjs";
import {deletedResourceAction, saveResourceChangelistSuccess} from "../../../resources/actions";
import {isNoU} from "../../../utils/DBUtils";

const deleteSelectedTagEpic = (action$, store) => action$.ofType(Types.DELETE_SELECTED_TAG)
    .mergeMap(() => {
        const {resources, deleteBreakTagModal, editBreak} = store.getState();
        let breakTag = resources.resources[deleteBreakTagModal.toDelete];
        let data = {};

        if (!isNoU(deleteBreakTagModal.deleteConfirmation)) {
            data.confirmation = deleteBreakTagModal.deleteConfirmation;
        }

        return ResourceApi.deleteResource(ResourceApi.Types.BreakTag, breakTag.id, [breakTag.resourceId], data)
            .mergeMap(() => {
                let actions = [
                    tagDeletedAction(),
                    deletedResourceAction(breakTag, breakTag, [breakTag.resourceId], [], [], {}, null)
                ];

                if (editBreak.break.MASTER) {
                    let currentBreak = resources.resources[editBreak.break.MASTER];
                    if (!isNoU(currentBreak.breakTagIds)) {
                        let index = currentBreak.breakTagIds.findIndex((tagId) => breakTag.id === tagId);
                        if (index !== -1) {
                            let tags = currentBreak.breakTagIds.slice();
                            console.log(tags.slice());
                            tags.splice(index, 1);
                            console.log(tags.slice());
                            actions.push(saveResourceChangelistSuccess(
                                ResourceApi.Types.BreakTag,
                                currentBreak.id,
                                [{
                                    field: "breakTagIds",
                                    value: tags
                                }],
                                currentBreak.id,
                                []
                            ));
                        }
                    }
                }

                return Observable.from(actions);
            })
            .catch((error) => {
                // will receive confirmation request from server
                // if any breaks have the break tag to be deleted
                let {response} = error;
                if (error.status === 412) {
                    return Observable.of(confirmDeleteSelectedTagAction(response.confirmationInfo, response.confirmation));
                }

                return Observable.of({
                    type: "ERROR",
                    error
                });
            })
    });


export default [
    deleteSelectedTagEpic
];



// WEBPACK FOOTER //
// ./public/pages/EditBreak/DeleteBreakTagModal/epics.js